<template>

  <modal :name="'push-client'" :adaptive="true" :clickToClose="false" :reset="true" width="400" :scrollable="true"
    :height="'auto'" @before-close="$emit('close', true)">
    <card>
      <form @submit.prevent>
        <label>ID ученика</label>
        <input v-model="id" :type="`text`" class="form-control mb-3" />
        <button @click="pushClient" class="btn btn-info w-100 mb-3" type="submit">Добавить</button>
      </form>
      <button class="btn btn-danger w-100 mb-2" @click="$modal.hide('push-client')">Отмена</button>
    </card>
  </modal>
</template>

<script>
import { errorNotify } from "@/plugins/functions";
export default {
  components: {

  },
  data() {
    return {
      id: null
    };
  },
  name: "paper-table",
  props: {

  },
  mounted() {
    this.$modal.show('push-client');
  },
  computed: {

  },
  methods: {
    pushClient() {

      this.$loading(true);
      let bodyFormData = new FormData();
      bodyFormData.append('_method', 'POST');
      bodyFormData.append('id', this.id);
      return this.$http
        ({
          url: `business/clients`,
          method: 'POST',
          data: bodyFormData,
          headers: {
            "Content-Type": "multipart/form-data",
            "Accept": "application/json",
            "api-version": "1",
            "platform": "web"
          }
        })
        .then((response) => {
          const data = response.data.data;
          let query = Object.assign({}, this.$route.query);
          if (query['item_client']) {
            delete query['item_client'];
          }
          query['item_client'] = data.id;
          this.$modal.hide('push-client');
          this.$store.dispatch("setLastUpdate", new Date());
          setTimeout(() => {
            this.$router.replace({ query: query });
          }, 20);
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
          return null;
        })
        .finally(() => {

          setTimeout(() => {
            this.$loading(false);
          }, 400);
        });
    }
  },
};
</script>